import React from 'react';
import { Skeleton } from '@mui/material';
import { ArcSkeletonProps } from './types';

const ArcSkeleton: React.FC<ArcSkeletonProps> = (props) => {
  return <Skeleton variant='rounded' {...props}/>;
};

export default ArcSkeleton;